export const donationPath = "https://enroll.pythiangames.org/auth/donation"